<template>
    <div class="a-container">
        <div class="intro">
            <blog-bcrumbs v-bind="bcrumbs" />
            <div class="news-title-mobile">
                {{ title }}
            </div>
            <div v-if="socialLinks" class="socials">
                <div class="social-label">
                    {{ translations.followUsOn }}
                </div>
                <a-social :social="socialLinks" />
            </div>
        </div>
    </div>
</template>

<script>
import ASocial from '@core/components/social/social.vue';
import BlogBcrumbs from '@core/slices/blog/blog-bcrumbs/blog-bcrumbs.vue';
import socials from '@model/const/socials.ts';

export default {
    name: 'SBlogCpsBcrumbs',
    components: {
        ASocial,
        BlogBcrumbs,
    },
    props: {
        title: {
            type: String,
            default: '',
        },

    },
    data() {
        return {
            socials,
        };
    },

    computed: {
        translations() {
            return this.$store.state.slices.items.blog || {};
        },

        bcrumbs() {
            const bcrumbs = [
                {
                    to: '/tru/',
                    title: this.translations.cpcTitle,
                },
                { title: this.title },
            ];
            return {
                theme: 'dark',
                bcrumbs,
                mobileLink: bcrumbs[0],
            };
        },

        socialLinks() {
            const linksSource = this.translations.customSocialLinks || socials.links;
            const links = Array.from(linksSource);
            const rss = {
                link: '/tru/feed.xml#',
                name: 'rss',
                title: 'RSS',
            };
            links.push(rss);
            return links;
        },
    },
};
</script>

<style lang="postcss" scoped>
.intro {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 24px;
    padding-bottom: 16px;
    @media (--viewport-desktop) {
        flex-direction: row;
        justify-content: space-between;
        margin-top: 32px;
        margin-bottom: 24px;
    }
    .news-title-mobile {
        @mixin display-accent;
        margin-bottom: 24px;
        color: var(--av-inversed-primary);
        @media (--viewport-desktop) {
            display: none;
        }
    }
    .socials {
        display:flex;
        align-items: center;
    }
    :deep(.a-social) {
        display: flex;
        flex-wrap: nowrap;
        justify-content: center;
        align-items: center;
        gap: 16px;
        &__link {
            display: flex;
            align-items: center;
            height: 100%;
            margin: 0;
        }
        &__icon {
            height: 16px;
            width: 16px;
        }
    }
    .social-label {
        @mixin body-accent;
        line-height: 16px;
        white-space: nowrap;
        margin-inline-end: 16px;
        color: var(--av-inversed-primary);
    }
}
</style>
